import { ValidatorFn, Validators as StandardValidators } from '@angular/forms';
import { isDefined } from 'ionic-angular/util/util';
import { CustomValidators } from './custom-validators';

export class ValidatorsFactory {

    getValidator(v: string | Object): ValidatorFn {
        if (typeof v === 'string') {
            return this.getValidatorForName(v);
        } else if (typeof v === 'object') {
            return this.getValidatorForObject(v);
        }
    }

    protected getValidatorForName(name: string): ValidatorFn {

        const _name = name === 'email' ? 'validOrEmptyEmail' : name;

        if (isDefined(StandardValidators[_name])) {
            return StandardValidators[_name];
        } else if (isDefined(CustomValidators[_name])) {
            return CustomValidators[_name];
        }
        return undefined;
    }

    protected getValidatorForObject(validatorObject: Object): ValidatorFn {
        if ((validatorObject as any).validator !== undefined && (validatorObject as any).args !== undefined) {
            return StandardValidators[(validatorObject as any).validator].apply(StandardValidators, ((validatorObject as any).args));
        }

        return undefined;
    }
}



// WEBPACK FOOTER //
// ./src/vas/validators/validators-factory.ts